/** 西派樘樾施工阶段与工序模板。日期一律留空，不预填假进度。 */

export const WORK_STATUSES = ['未开始', '交底完成', '施工中', '待验收', '已验收', '整改中'];

export const WORK_PHASES = [
  {
    key: 'pre',
    name: '开工前',
    hint: '图纸、报价、物业手续和成品保护先锁，再让鲁班进场。',
    items: [
      {
        key: 'pre-drawings',
        name: '设计图纸确认',
        owner: '我 / 鲁班',
        notes: '效果图与施工图对照现场。门窗洞、吊顶高度、空调检修口未定前不要让拆改开工。',
        checks: ['效果图已确认', '施工图与现场一致', '门窗洞口已复核', '空调风口与检修口已对照吊顶'],
      },
      {
        key: 'pre-budget',
        name: '预算与报价单',
        owner: '我 / 鲁班 / 意立森',
        notes: '半包、定制、封窗、大金合同额进订单。家电嵌入尺寸写入选型，再给橱柜深化。',
        checks: ['四合同成交价已录入', '定制深化要点已确认', '冰箱洗碗机嵌入尺寸已交给橱柜'],
      },
      {
        key: 'pre-property',
        name: '办理物业手续',
        owner: '我 / 鲁班',
        notes: '装修登记、电梯使用、施工时段、材料进场路线按物业规定办完再开工。',
        checks: ['装修登记已办', '电梯与进场路线已确认', '正式开工日已与项目经理对齐'],
      },
      {
        key: 'pre-protect',
        name: '开工前成品保护',
        owner: '鲁班',
        notes: '公共走道、入户门、电梯轿厢、成品窗框先保护。拆改垃圾日清。',
        checks: ['公共区域已保护', '门窗框已保护', '垃圾清运约定已明确'],
      },
    ],
  },
  {
    key: 'demo',
    name: '拆改',
    hint: '先交底再动手。拆完验收墙体、管线、垃圾，再交给水电。',
    items: [
      {
        key: 'demo-brief',
        name: '拆改交底',
        owner: '鲁班',
        notes: '对照图纸标明拆墙、门洞改位、管线拆除范围。承重墙与烟道不可拆。',
        checks: ['拆改范围已现场标画', '承重与烟道已避开', '邻居与物业已知会'],
      },
      {
        key: 'demo-done',
        name: '拆改完成',
        owner: '鲁班',
        notes: '拆完清运，墙体基层、原有管线暴露点拍照留底。',
        checks: ['垃圾已清运', '基层已清理', '拆改照片已留底'],
      },
    ],
  },
  {
    key: 'window',
    name: '封窗',
    hint: '斯柏瑞合同。常与拆改、水电交叉，单独成章，不挡住水电推进。',
    parallel: true,
    orderHint: 'window',
    items: [
      {
        key: 'window-install',
        name: '封窗安装',
        owner: '斯柏瑞',
        notes: '窗框进场前保护地面与墙面。安装后查开启、密封、排水孔。厨房窗若未签约，不要估尺寸。',
        checks: ['窗号与合同一致', '密封与排水已查', '成品保护未撤'],
      },
    ],
  },
  {
    key: 'me',
    name: '水电改造',
    hint: '定位交底 → 开槽布线 → 水路 → 验收闭水。隐蔽前必须拍照。',
    items: [
      {
        key: 'me-brief',
        name: '水电定位交底',
        owner: '鲁班',
        notes: '开关插座、灯位、给排水、冰箱洗碗机点位按图纸上墙。与橱柜、岛台、空调冷凝水对齐。',
        checks: ['点位已上墙', '厨电点位已对照橱柜', '空调冷凝水路径已定'],
      },
      {
        key: 'me-slot',
        name: '开槽与布线规范',
        owner: '鲁班',
        notes: '横平竖直，强弱电分管分槽。线管不宜重叠。开槽深度不影响结构。',
        checks: ['强弱电已分离', '开槽横平竖直', '线管固定到位'],
      },
      {
        key: 'me-water',
        name: '水路改造',
        owner: '鲁班',
        notes: '冷热水管走向、阀门、地漏坡度一次定好。改完先打压再封槽。',
        checks: ['冷热水管已标识', '打压试验已做', '地漏坡度已查'],
      },
      {
        key: 'me-accept',
        name: '水电验收',
        owner: '我 / 鲁班',
        notes: '闭水、通电、点位对照图纸。隐蔽工程照片进日志并挂到本工序。',
        checks: ['闭水试验通过', '点位与图纸一致', '隐蔽照片已归档'],
      },
    ],
  },
  {
    key: 'tile',
    name: '泥瓦',
    hint: '包立管 → 防水 → 贴砖。防水未验收不要贴砖。',
    items: [
      {
        key: 'tile-pipe',
        name: '包立管',
        owner: '鲁班',
        notes: '厨房卫生间立管基层牢固，检修口预留，与瓷砖模数对齐。',
        checks: ['基层牢固', '检修口已留', '尺寸与砖模对齐'],
      },
      {
        key: 'tile-waterproof',
        name: '防水',
        owner: '鲁班',
        notes: '墙面高度按规范。闭水 24–48 小时，无渗漏再下道。',
        checks: ['墙高达到约定', '闭水已做', '无渗漏'],
      },
      {
        key: 'tile-lay',
        name: '贴砖',
        owner: '鲁班',
        notes: '排砖、空鼓、倒角、坡度一次查。美缝留到安装阶段。',
        checks: ['空鼓已敲检', '坡度正确', '砖缝均匀'],
      },
    ],
  },
  {
    key: 'hvac',
    name: '中央空调',
    hint: '大金一拖六。吊顶前吊装内机、管道保压；吊顶后装风口面板并调试验收。',
    orderHint: 'daikin',
    items: [
      {
        key: 'hvac-install',
        name: '内机吊装与管道安装',
        owner: '大金',
        notes: '吊顶前完成内机定位、冷媒管、冷凝水、保温与保压。与吊顶检修口、风口位置对照图纸。',
        checks: ['内机位置与图纸一致', '管道保压已做', '冷凝水坡度正确', '检修口可开启'],
      },
      {
        key: 'hvac-commission',
        name: '风口面板与调试验收',
        owner: '大金 / 鲁班',
        notes: '吊顶完成后装风口面板（可与木工交叉：内机先装，风口后装）。通冷媒、试机、查漏。遥控器与分区对照合同。',
        checks: ['风口面板已装', '试机制冷制热正常', '无渗漏', '合同设备型号已核对'],
      },
    ],
  },
  {
    key: 'wood',
    name: '木工',
    hint: '吊顶与造型。风口、检修口、灯槽与定制上墙位置先复核。',
    items: [
      {
        key: 'wood-ceiling',
        name: '吊顶',
        owner: '鲁班',
        notes: '龙骨平整，检修口可开。中央空调风口、灯位、烟感与吊顶完成面一并核对。',
        checks: ['龙骨平整', '检修口可开启', '风口灯位已复核'],
      },
      {
        key: 'wood-shape',
        name: '其他造型',
        owner: '鲁班',
        notes: '背景墙基层、门洞套口、石膏线等按图施工，预留完成面给定制和石材。',
        checks: ['造型与图纸一致', '完成面已预留', '基层无松动'],
      },
    ],
  },
  {
    key: 'paint',
    name: '油漆',
    hint: '腻子基层过关再上乳胶漆。阴阳角、裂缝先处理。',
    items: [
      {
        key: 'paint-base',
        name: '基层处理，腻子',
        owner: '鲁班',
        notes: '空鼓开裂先补。打磨平整后再罩面。',
        checks: ['空鼓已处理', '阴阳角顺直', '打磨到位'],
      },
      {
        key: 'paint-latex',
        name: '乳胶漆',
        owner: '鲁班',
        notes: '遍数按约定。保护已装窗、开关底盒、地面砖。',
        checks: ['遍数已完成', '色差可接受', '成品无污染'],
      },
    ],
  },
  {
    key: 'custom',
    name: '全屋定制入场',
    hint: '意立森。墙顶地完成面到位后再进场，复尺以现场为准。',
    orderHint: 'custom',
    items: [
      {
        key: 'custom-install',
        name: '全屋定制安装',
        owner: '意立森',
        notes: '柜体按报价空间对板。收口、五金、台面与水电点位现场复核。',
        checks: ['板块与报价一致', '收口完成', '五金已调试'],
      },
    ],
  },
  {
    key: 'install',
    name: '安装',
    hint: '主材集中进场。顺序：美缝与电、厨卫洁具、门地板；橱柜衣柜归全屋定制章，窗帘家具归软装章。',
    items: [
      {
        key: 'inst-grout',
        name: '美缝 / 瓷缝',
        owner: '鲁班 / 美缝师傅',
        notes: '砖缝干燥、干净再做。颜色先小样。',
        checks: ['砖缝已清理', '色样已确认', '表面无残留'],
      },
      {
        key: 'inst-switch',
        name: '开关插座灯具',
        owner: '鲁班',
        notes: '面板与灯具按回路安装，与吊顶、柜体完成面齐平。',
        checks: ['回路正确', '面板平整', '灯具已试亮'],
      },
      {
        key: 'inst-bath-ceiling',
        name: '厨卫集成吊顶、浴霸、凉霸',
        owner: '鲁班',
        notes: '扣板、收边、浴霸凉霸与排风、电源一次装完。',
        checks: ['扣板平整', '浴霸凉霸已试', '收边无缝'],
      },
      {
        key: 'inst-kitchen-eq',
        name: '热水器、油烟机、燃气灶、水槽',
        owner: '鲁班 / 品牌师傅',
        notes: '燃气与热水须持证安装。烟管、冷热水管、下水管不漏。',
        checks: ['燃气已试压', '烟机排烟顺畅', '水槽下水不漏'],
      },
      {
        key: 'inst-sanitary',
        name: '卫浴洁具',
        owner: '鲁班',
        notes: '马桶、花洒、龙头安装后通水。密封与坡度再查一次。',
        checks: ['通水无渗漏', '马桶稳固', '花洒出水正常'],
      },
      {
        key: 'inst-door',
        name: '室内门、门套',
        owner: '鲁班 / 门厂',
        notes: '门扇垂直，锁具灵活，套口与墙面收口干净。',
        checks: ['开关顺畅', '锁具正常', '套口收口完成'],
      },
      {
        key: 'inst-floor',
        name: '地板、踢脚线',
        owner: '鲁班',
        notes: '基层干燥。踢脚与门套、橱柜收口预先放样。',
        checks: ['基层干燥', '地板无空鼓响', '踢脚收口整齐'],
      },
    ],
  },
  {
    key: 'clean',
    name: '开荒保洁',
    hint: '安装基本结束后做一次，软装进场前再补一次局部。',
    items: [
      {
        key: 'clean-open',
        name: '开荒保洁',
        owner: '保洁',
        notes: '去胶、去水泥、玻璃、地板、厨卫死角。保洁后少进工地。',
        checks: ['玻璃无胶', '厨卫无水泥', '地板无划伤'],
      },
    ],
  },
  {
    key: 'soft',
    name: '软装进场',
    hint: '沙发、床、餐桌、窗帘、饰品。与家电软装页的最终项对照。',
    items: [
      {
        key: 'soft-move',
        name: '软装进场',
        owner: '我',
        notes: '按空间就位。包装带走。有破损当场拍照找商家。',
        checks: ['大件已就位', '破损已记录', '包装已清走'],
      },
    ],
  },
  {
    key: 'voc',
    name: '除甲醛',
    hint: '通风为主。治理公司若使用，留检测报告，不编造数值。',
    items: [
      {
        key: 'voc-treat',
        name: '除甲醛',
        owner: '我',
        notes: '开窗通风。若请治理或检测，把报告放进文件中心。',
        checks: ['已持续通风', '若有检测报告已归档'],
      },
    ],
  },
  {
    key: 'movein',
    name: '入住',
    hint: '钥匙、物业、维保联系人、剩余尾款一次收口。',
    items: [
      {
        key: 'movein-live',
        name: '入住',
        owner: '我',
        notes: '尾款按合同节点付。质保卡、说明书、供应商电话集中放文件中心。',
        checks: ['尾款节点已核', '质保资料已收', '物业已告知入住'],
      },
    ],
  },
];

export function allWorkTemplates() {
  const rows = [];
  WORK_PHASES.forEach((phase, pi) => {
    phase.items.forEach((item, ii) => {
      rows.push({
        ...item,
        phase: phase.name,
        phaseKey: phase.key,
        orderHint: item.orderHint || phase.orderHint || '',
        sort: pi * 100 + ii + 1,
      });
    });
  });
  return rows;
}

export function workPhaseOf(key) {
  return WORK_PHASES.find((p) => p.key === key) || null;
}

export function workTemplateByKey(key) {
  return allWorkTemplates().find((x) => x.key === key) || null;
}
